/* Short English banner copy only; Shopify continues to own all consent choices. */
(() => {
  function compactCopy() {
    const p = document.querySelector('#shopify-pc__banner .shopify-pc__banner__body p');
    if (!p) return false;
    const link = p.querySelector('#shopify-pc__banner__body-policy-link');
    if (link && /^We use cookies and other technologies/.test(p.textContent.trim())) {
      p.replaceChildren(document.createTextNode('Cookies for personalization, marketing & analytics. '), link);
    }
    return true;
  }
  if (compactCopy()) return;
  const observer = new MutationObserver(() => { if (compactCopy()) observer.disconnect(); });
  observer.observe(document.body, {childList: true, subtree: true});
  window.setTimeout(() => observer.disconnect(), 30000);
})();
/* Keep Shopify Inbox above the actual cookie banner height, including safe-area padding. */
(() => {
  let banner;
  const update = () => {
    const height = banner && getComputedStyle(banner).visibility !== 'hidden' ? banner.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--atl-cookie-chat-offset', `${height}px`);
  };
  function connect() {
    banner = document.querySelector('#shopify-pc__banner');
    if (!banner) return false;
    new ResizeObserver(update).observe(banner);
    new MutationObserver(update).observe(banner, {attributes: true, attributeFilter: ['style', 'class', 'hidden']});
    window.addEventListener('resize', update, {passive: true});
    update();
    return true;
  }
  if (connect()) return;
  const observer = new MutationObserver(() => { if (connect()) observer.disconnect(); });
  observer.observe(document.body, {childList: true, subtree: true});
  window.setTimeout(() => observer.disconnect(), 30000);
})();
